import { render } from "./ListaFornecedores.vue?vue&type=template&id=df31f742"
import script from "./ListaFornecedores.vue?vue&type=script&lang=js"
export * from "./ListaFornecedores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__